var _style, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvolution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 90",
    style: {
      enableBackground: "new 0 0 80 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#898989;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_00000160153527495277372410000010244823552126387888_);}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.39,41.78c3.81,0.21,8.04,0,12.48-0.42c-0.63-9.31-3.6-16.93-8.25-22.85c0.21,1.69,0.42,3.39,0.42,5.08 C60.04,30.15,58.35,36.49,55.39,41.78z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.69,44.53c-6.77,10.16-18.41,16.93-31.52,16.93c-0.85,0-1.9,0-2.75-0.21c-3.39,5.08-5.5,10.79-7.83,16.29 c23.48,12.48,53.95-0.63,56.28-32.79C62.58,44.32,57.92,44.32,53.69,44.53z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 1064.188,
    cy: -240.1787,
    r: 32.1196,
    fx: 1032.1405,
    fy: -238.0298,
    gradientTransform: "matrix(-0.8331 -0.5531 0.4978 -0.7498 1041.9321 431.5128)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1977,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2872,
    style: {
      stopColor: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4437,
    style: {
      stopColor: "#969696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5434,
    style: {
      stopColor: "#898989"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7002,
    style: {
      stopColor: "#686868"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.59,8.78c6.56,14.81,11.42,31.95,43.8,33.01c2.96-5.5,4.65-11.64,4.65-18.2c0-1.69-0.21-3.39-0.42-5.08 C48.62,3.91,28.3-0.11,11.59,8.78z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000064343018589785974720000005733115452802006190_",
    cx: 895.5749,
    cy: -69.3446,
    r: 13.5044,
    fx: 888.1673,
    fy: -69.1874,
    gradientTransform: "matrix(-0.4226 -0.9063 2.3873 -1.1132 580.6458 787.3823)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1155,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1694,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2654,
    style: {
      stopColor: "#C2C2C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7835,
    style: {
      stopColor: "#909090"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000064343018589785974720000005733115452802006190_)"
    },
    d: "M53.69,44.53 c-19.46,0.85-28.56,8.04-34.27,16.71c0.85,0,1.9,0.21,2.75,0.21C35.5,61.46,46.92,54.69,53.69,44.53z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvolution);
export default __webpack_public_path__ + "static/media/evolution.970486cf73863886edf61e92cbe20b35.svg";
export { ForwardRef as ReactComponent };